import React from 'react';
import { autobind } from 'core-decorators';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import Dialog from '../../../componentes/dialog';
import Button from '../../../componentes/button';
import { Input } from 'reactstrap';
import LucideIcon from '../../../componentes/lucide-icon';
import { Form } from '../../../utils/form';
import errorHandler from '../../../utils/error-handler';
import LoadingContainer from '../../../componentes/loading-container';
import Alert from '../../../componentes/message-box/alert';
import Confirm from '../../../componentes/message-box/confirm';
import ContentManager from '../../../componentes/content-manager';
import http from 'src/services/httpService';
import history from '../../../history';
import { TIPO_ITENS, MODULOS, MODELO_ITEM } from 'src/utils/constants';
import StageGateLookup from 'src/lookups/stageGeteLookup';
import CreateStageGate from 'src/paginas/projeto/StageGate/Edit';
import { getStageGateSchema } from 'src/paginas/projeto/StageGate/Edit/schema';
import Resumo from './resumo';

@autobind
class Template extends React.Component {
  constructor(props) {
    super(props);
    this.salvo = false;
    this.state = {
      isLoading: false,
      isLoadingParams: false,
      modeloItem: this.props.modeloItem ? this.props.modeloItem : null,
      opcaoSelecionada: null,
      opcaoFluxo: null,
      fluxoSelecionado: null,
    };

    this.form = new Form({
      component: this,
      schema: this.props.schema,
    });
  }

  async componentDidMount() {
    this.setState({
      isLoading: true,
    });

    try {
      var response = await http.post(`${this.props.url}/Create`, {
        parameters: this.props.parameters,
      });
      this.setState({ isLoading: false });
      this.handleSetFormValues(response.data);
      //this.form.setValue(null, response.data);
    } catch (error) {
      this.setState({ isLoading: false });
      errorHandler(error);
    }
  }

  handleClose() {
    this.refs.dialog.close();
    setTimeout(() => {
      this.props.remove && this.props.remove();
      this.props.handleClose &&
        this.props.handleClose(this.salvo, this.form.getValue('id'));
      this.salvo = false;
    }, 300);
  }

  redirecionaRegistroCriado(novoId) {
    var tipo = this.form.getModel('tipo').value;
    var urlEdit = '';

    if (tipo.id === 1) {
      urlEdit = '/gerenciar/indicador/edit';
    } else if (tipo.id === 2) {
      urlEdit = '/gerenciar/parametro/edit';
    } else if (tipo.id === 3) {
      urlEdit = '/gerenciar/objetivo-estrategico/edit';
    } else if (tipo.id === 4) {
      urlEdit = '/gerenciar/projeto/edit';
    } else if (tipo.id === 6) {
      urlEdit = '/gerenciar/risco/edit';
    } else if (tipo.id === 5) {
      urlEdit = '/gerenciar/processo/edit';
    } else if (tipo.id === 10) {
      urlEdit = '/rv/gerenciar/desempenho-individual/edit';
    } else if (tipo.id === 11) {
      urlEdit = '/rv/gerenciar/calculo-intermediario/edit';
    } else if (tipo.id === 17) {
      urlEdit = '/gerenciar/indicador-risco/edit';
    }

    if (urlEdit) {
      const id = novoId || this.form.getValue('id');
      let search = `id=${id}`;
      if (this.props.handleUnificarItemRascunho) {
        search = search + '&ehItemRascunho=true';
      }

      history.push({
        pathname: `${urlEdit}`,
        search: search,
      });
    }
  }

  handleBack() {
    if (this.state.modeloItem) {
      this.setState({ modeloItem: null });
    } else {
      this.handleClose();
    }
  }

  handleSetCriarItensFormula(criarItens) {
    this.setState({ criarItensFormulaTemplate: criarItens });
  }

  handleValidate(shouldCloseAfterSave = true) {
    var model = this.form.getModel();

    if (!this.form.isValid()) {
      this.form.showAllErrors();
      ContentManager.addContent(
        <Alert
          message={
            <FormattedMessage id="label.osCamposDestacadosEmVermelhoSaoObrigatoriosFavorPreenchelos" />
          }
        />
      );
      return;
    }

    let itemTemplate = model.getModel('itemTemplate').value;

    if (itemTemplate != null && itemTemplate.possuiFormula == true) {
      ContentManager.addContent(
        <Confirm
          handleConfirm={this.handleSave.bind(this, true)}
          handleCancel={this.handleSave.bind(this, false)}
          message={
            <FormattedMessage id="criarItensDaFormulaAssociadosNoTemplate" />
          }
          handle
        />
      );
    } else {
      this.handleSave(false, shouldCloseAfterSave);
    }
  }

  async handleSave(criarItensFormulaTemplate = false, shouldClose = true) {
    let { modeloItem } = this.state;
    var model = this.form.getModel();

    this.setState({ isLoading: true });
    try {
      var response = await http.post(`${this.props.url}/Save`, {
        model: this.form.getValue(),
        parameters: {
          modeloItemId: modeloItem && modeloItem.id,
          criarItensFormulaAssociadaAoTemplate: criarItensFormulaTemplate,
          TemplateDesdobramentoId:
            model.getModel('templateDesdobramento').value &&
            model.getModel('templateDesdobramento').value.id,
          ...this.props.parameters,
        },
      });
      const savedModel = response.data.model;
      this.form.setValue(null, savedModel);
      this.salvo = true;
      this.setState({ isLoading: false });

      if (this.props.handleUnificarItemRascunho) {
        var itemCriado = {
          id: savedModel.id,
          tipo: this.form.getModel('tipo').value,
        };
        this.props.handleUnificarItemRascunho(itemCriado);
      }

      if (shouldClose) {
        this.handleClose();
        this.redirecionaRegistroCriado(savedModel.id);
      }
    } catch (error) {
      this.setState({ isLoading: false });
      errorHandler(error);
    }
  }

  handleConfirmSendApproval() {
    ContentManager.addContent(
      <Confirm
        message={this.props.intl.formatMessage(
          {
            id: 'enviarParaAprovacaoConfirmacao',
          },
          { projeto: this.props.resources.projeto }
        )}
        handleConfirm={this.handleSendApproval.bind(this)}
      />
    );
  }

  async handleSendApproval() {
    var model = this.form.getModel();

    this.setState({ isLoading: true });
    try {
      await http.post(`StageGate/EnviarParaAprovacao`, {
        projeto: { id: model.getModel('id').value },
        stageGate: model.getModel('stageGate').value,
        etapaId: model.getModel('etapaAtualStageGate').value?.id,
      });

      this.setState({ isLoading: false });
      this.handleClose();
      this.redirecionaRegistroCriado();
    } catch (error) {
      this.setState({ isLoading: false });
      errorHandler(error);
    }
  }

  handleOpcaoChange(opcaoId) {
    this.setState({ opcaoSelecionada: opcaoId });
  }

  handleOpcaoFluxoChange(opcaoId) {
    this.setState({ opcaoFluxo: opcaoId });
  }

  handleAvancar() {
    const { opcaoFluxo, opcaoSelecionada, fluxoSelecionado } = this.state;
    const { utilizarTemplateProjeto } = this.obterConfiguracaoSistema();
    const { tipoItem } = this.props;

    const hasEPModule = this.props.modules.find(
      (m) => m.id === MODULOS.ESCRITORIO_PROJETOS && m.ativo
    );

    const isProjetoComFluxo = tipoItem === TIPO_ITENS.PROJETO && hasEPModule;

    if (isProjetoComFluxo && !fluxoSelecionado) {
      if (!opcaoFluxo) return;

      const novoFluxo = opcaoFluxo === 1 ? 'tradicional' : 'stage-gate';
      this.setState({ fluxoSelecionado: novoFluxo, opcaoFluxo: null });

      if (novoFluxo === 'stage-gate') {
        this.setState({ modeloItem: { id: 4 } });
        this.form.schema = getStageGateSchema();
      } else if (novoFluxo === 'tradicional') {
        if (!utilizarTemplateProjeto) {
          this.setState({ modeloItem: { id: 1 } });
        }
      }
      return;
    }

    if (!opcaoSelecionada) return;

    let modeloItemId;
    if (opcaoSelecionada === 1) {
      modeloItemId = MODELO_ITEM.INDIVIDUAL;
    } else if (opcaoSelecionada === 2) {
      modeloItemId = MODELO_ITEM.TEMPLATE;
    } else if (opcaoSelecionada === 3) {
      modeloItemId = MODELO_ITEM.ITEMTEMPLATE;
    }

    this.setState({ modeloItem: { id: modeloItemId } });
  }

  handleSetFormValues(value) {
    this.form.setValue(null, value);
  }

  handleColumnSize(
    habilitaOpcaoTemplateItem,
    utilizarDesdobramento,
    modeloSelecionado,
    tipoItem
  ) {
    if (tipoItem == TIPO_ITENS.PROJETO) return 6;
    if (modeloSelecionado) return 6;

    if (habilitaOpcaoTemplateItem || utilizarDesdobramento) {
      if (
        (habilitaOpcaoTemplateItem && !utilizarDesdobramento) ||
        (!habilitaOpcaoTemplateItem && utilizarDesdobramento)
      )
        return 6;

      return 4;
    }

    return 12;
  }

  obterConfiguracaoSistema() {
    return this.props.configuracaoSistema ? this.props.configuracaoSistema : {};
  }

  render() {
    const { tipoItem, intl, resources, handleUnificarItemRascunho, modules } =
      this.props;
    const { modeloItem, opcaoFluxo, fluxoSelecionado, opcaoSelecionada } =
      this.state;
    const ehItemRascunho = handleUnificarItemRascunho;

    const hasEPModule = modules.find(
      (m) => m.id === MODULOS.ESCRITORIO_PROJETOS && m.ativo
    );

    let {
      utilizarTemplateIndicador,
      utilizarTemplateParametro,
      utilizarTemplateObjetivoEstrategico,
      utilizarFuncionalidadeDesdobramento,
      utilizarTemplateProjeto,
    } = this.obterConfiguracaoSistema();

    if (handleUnificarItemRascunho) {
      utilizarTemplateIndicador = false;
      utilizarTemplateParametro = false;
      utilizarTemplateObjetivoEstrategico = false;
      utilizarFuncionalidadeDesdobramento = false;
      utilizarTemplateProjeto = false;
    }

    const habilitaOpcaoTemplateItem =
      (tipoItem == 1 && utilizarTemplateIndicador) ||
      (tipoItem == 2 && utilizarTemplateParametro) ||
      (tipoItem == 3 && utilizarTemplateObjetivoEstrategico) ||
      (tipoItem == TIPO_ITENS.PROJETO && utilizarTemplateProjeto);

    const model = this.form.getModel();

    const allowCreateTraditionalProjects = model.getModel(
      'allowCreateProjetosTradicionais'
    ).value;
    const allowCreateStageGateProjects = model.getModel(
      'allowCreateProjetosStageGate'
    ).value;

    const showSelecaoFluxo =
      !ehItemRascunho &&
      !modeloItem &&
      hasEPModule &&
      tipoItem === TIPO_ITENS.PROJETO &&
      !fluxoSelecionado;

    const showOpcoesTemplateBase =
      !ehItemRascunho &&
      !modeloItem &&
      (tipoItem == 1 ||
        tipoItem == 2 ||
        tipoItem == 3 ||
        (tipoItem == TIPO_ITENS.PROJETO && utilizarTemplateProjeto));

    const showOpcoesTemplate =
      showOpcoesTemplateBase &&
      (tipoItem !== TIPO_ITENS.PROJETO || fluxoSelecionado === 'tradicional');

    const hasStageGate = !!model.getModel('stageGate').value;

    const editActions = [
      <div key="edit-toolbar">
        {hasStageGate ? (
          <>
            <Button color="secondary" onClick={this.handleClose}>
              <FormattedMessage id="label.cancelar" />
            </Button>
            <Button
              className="ml-2"
              onClick={() => {
                this.handleValidate(true);
              }}
            >
              <FormattedMessage id="label.salvar" />
            </Button>
            <Button
              className="ml-2"
              color="primary"
              onClick={this.handleConfirmSendApproval}
              disabled={model.getModel('id').value === 0}
            >
              <FormattedMessage id="enviarParaAprovacao" />
            </Button>
          </>
        ) : (
          <>
            {!ehItemRascunho &&
              tipoItem != TIPO_ITENS.PROJETO &&
              tipoItem != TIPO_ITENS.TEMPLATE_PROJETO &&
              tipoItem != 10 &&
              tipoItem != 11 && (
                <Button color="secondary" onClick={this.handleBack}>
                  <FormattedMessage id="label.voltar" />
                </Button>
              )}
            <Button className="ml-2" onClick={this.handleValidate}>
              <FormattedMessage id="label.salvarEFechar" />
            </Button>
          </>
        )}
      </div>,
    ];

    const buttonMessage = showSelecaoFluxo
      ? 'avancar'
      : tipoItem === TIPO_ITENS.PROJETO && fluxoSelecionado === 'tradicional'
      ? 'cadastrar'
      : 'avancar';

    const opcoesTemplateActions = [
      <div key="opcoes-toolbar">
        <Button
          color="secondary"
          onClick={this.handleClose}
          className={fluxoSelecionado && showOpcoesTemplate ? 'ml-2' : ''}
        >
          <FormattedMessage id="label.cancelar" />
        </Button>
        <Button
          className="ml-2"
          onClick={this.handleAvancar}
          disabled={
            showSelecaoFluxo
              ? !opcaoFluxo ||
                (opcaoFluxo === 2 && !model.getModel('stageGate')?.value)
              : !opcaoSelecionada
          }
        >
          <FormattedMessage id={buttonMessage} />
        </Button>
      </div>,
    ];

    let title;
    if (showSelecaoFluxo) {
      title = intl.formatMessage(
        {
          id: 'tipoGerenciamentoDeProjeto',
        },
        { projeto: resources.projeto }
      );
    } else if (showOpcoesTemplate && fluxoSelecionado === 'tradicional') {
      title = intl.formatMessage(
        {
          id: 'tipoDeProjetoTradicional',
        },
        { projeto: resources.projeto }
      );
    } else {
      title =
        tipoItem == TIPO_ITENS.PROJETO ||
        tipoItem == TIPO_ITENS.TEMPLATE_PROJETO ? (
          <FormattedMessage id="label.novo" />
        ) : (
          <FormattedMessage id="label.novoItem" />
        );
    }

    return (
      <Dialog
        ref="dialog"
        title={title}
        textCapitalizeTitle={false}
        titleCapitalizeNone={true}
        width={showSelecaoFluxo || showOpcoesTemplate ? '500px' : '1500px'}
        style={{
          fontSize: 14,
          padding: '24px',
        }}
        onRequestClose={this.handleClose}
        styleHeader={{
          padding: '0',
        }}
        styleFooter={{
          padding: '0',
        }}
        styleTitle={{
          fontSize: '18px',
          fontWeight: 'bold',
          color: '#000000',
          marginBottom: '0',
        }}
        removeTitleMargin={true}
        showClose={true}
        customClose={(handleClose) => (
          <LucideIcon
            icon="close"
            onClick={handleClose}
            className="cursor-pointer fs-5 text-dark"
          />
        )}
        actions={
          showSelecaoFluxo || showOpcoesTemplate
            ? opcoesTemplateActions
            : (ehItemRascunho ||
                modeloItem ||
                (tipoItem != 1 && tipoItem != 2 && tipoItem != 3)) &&
              editActions
        }
      >
        <LoadingContainer
          isLoading={this.state.isLoading}
          className="p-0"
          style={{
            overflow:
              showSelecaoFluxo || showOpcoesTemplate ? 'hidden' : 'auto',
          }}
        >
          {showSelecaoFluxo ? (
            <div className="mt-4 mb-4 h-auto d-flex flex-column">
              <label
                htmlFor="opcaoFluxo1"
                className="d-flex flex-row mb-2 cursor-pointer"
                style={{ padding: '8px', borderRadius: '4px' }}
              >
                <div className="d-flex align-items-center pe-3">
                  <Input
                    type="radio"
                    name="opcaoFluxo"
                    id="opcaoFluxo1"
                    checked={opcaoFluxo === 1}
                    disabled={!allowCreateTraditionalProjects}
                    onChange={() => this.handleOpcaoFluxoChange(1)}
                    style={{
                      margin: '0px',
                      marginRight: '12px',
                      position: 'relative',
                    }}
                  />
                </div>
                <div className="flex-fill">
                  <div style={{ fontWeight: 'bold' }}>
                    <FormattedMessage id="tradicional" />
                  </div>
                  <div className="fs-6 text-muted">
                    {intl.formatMessage({
                      id: 'mensagemProjetoTradicional',
                    })}
                  </div>
                </div>
              </label>
              <div>
                <label
                  htmlFor="opcaoFluxo2"
                  className="d-flex mb-2 cursor-pointer"
                  style={{ padding: '8px', borderRadius: '4px' }}
                >
                  <div className="d-flex align-items-center pe-3">
                    <Input
                      type="radio"
                      name="opcaoFluxo"
                      id="opcaoFluxo2"
                      checked={opcaoFluxo === 2}
                      disabled={!allowCreateStageGateProjects}
                      onChange={() => this.handleOpcaoFluxoChange(2)}
                      style={{
                        margin: '0px',
                        marginRight: '12px',
                        position: 'relative',
                      }}
                    />
                  </div>
                  <div className="flex-fill">
                    <div style={{ fontWeight: 'bold' }}>
                      {intl.formatMessage(
                        {
                          id: 'stagegate',
                        },
                        { stagegate: resources.stagegate }
                      )}
                    </div>
                    <div className="fs-6 text-muted">
                      {intl.formatMessage({
                        id: 'mensagemProjetoStageGate',
                      })}
                    </div>
                  </div>
                </label>
                <div className="ml-4">
                  <StageGateLookup
                    style={{ marginBottom: 5 }}
                    model={{
                      value: model.getModel('stageGate').value,
                      requestChange: model.getModel('stageGate').requestChange,
                    }}
                    disabled={!allowCreateStageGateProjects || opcaoFluxo !== 2}
                  />
                  <spam>
                    {intl.formatMessage(
                      { id: 'selecioneStageGate' },
                      { stagegate: resources.stagegate }
                    )}
                  </spam>
                </div>
              </div>
            </div>
          ) : showOpcoesTemplate ? (
            <div className="mt-4 mb-4 h-auto d-flex flex-column">
              <label
                htmlFor="opcaoItem1"
                className="d-flex flex-row mb-2 cursor-pointer"
                style={{ padding: '8px', borderRadius: '4px' }}
              >
                <div className="d-flex align-items-center pe-3">
                  <Input
                    type="radio"
                    name="opcaoItem"
                    id="opcaoItem1"
                    checked={this.state.opcaoSelecionada === 1}
                    onChange={() => this.handleOpcaoChange(1)}
                    style={{
                      margin: '0px',
                      marginRight: '12px',
                      position: 'relative',
                    }}
                  />
                </div>
                <div className="flex-fill">
                  <div style={{ fontWeight: 'bold' }}>
                    <FormattedMessage id="templateIndividual" />
                  </div>
                  <div className="fs-6 text-muted">
                    {tipoItem == TIPO_ITENS.PROJETO ? (
                      intl.formatMessage(
                        { id: 'templateIndividualProjetoMensagem' },
                        { projeto: resources.projeto }
                      )
                    ) : (
                      <FormattedMessage id="templateIndividualMensagem" />
                    )}
                  </div>
                </div>
              </label>
              {utilizarFuncionalidadeDesdobramento &&
                tipoItem != TIPO_ITENS.PROJETO && (
                  <label
                    htmlFor="opcaoItem2"
                    className="d-flex mb-2 cursor-pointer"
                    style={{ padding: '8px', borderRadius: '4px' }}
                  >
                    <div className="d-flex align-items-center pe-3">
                      <Input
                        type="radio"
                        name="opcaoItem"
                        id="opcaoItem2"
                        checked={this.state.opcaoSelecionada === 2}
                        onChange={() => this.handleOpcaoChange(2)}
                        style={{
                          margin: '0px',
                          marginRight: '12px',
                          position: 'relative',
                        }}
                      />
                    </div>
                    <div className="flex-fill">
                      <div style={{ fontWeight: 'bold' }}>
                        <FormattedMessage id="label.templateDesdobramento" />
                      </div>
                      <div className="fs-6 text-muted">
                        <FormattedMessage id="templateDesdobramentoMensagem" />
                      </div>
                    </div>
                  </label>
                )}
              {habilitaOpcaoTemplateItem && (
                <label
                  htmlFor="opcaoItem3"
                  className="d-flex mb-2 cursor-pointer"
                  style={{ padding: '8px', borderRadius: '4px' }}
                >
                  <div className="d-flex align-items-center pe-3">
                    <Input
                      type="radio"
                      name="opcaoItem"
                      id="opcaoItem3"
                      checked={this.state.opcaoSelecionada === 3}
                      onChange={() => this.handleOpcaoChange(3)}
                      style={{
                        margin: '0px',
                        marginRight: '12px',
                        position: 'relative',
                      }}
                    />
                  </div>
                  <div className="flex-fill">
                    <div style={{ fontWeight: 'bold' }}>
                      {tipoItem == TIPO_ITENS.PROJETO ? (
                        <FormattedMessage id="template" />
                      ) : (
                        <FormattedMessage id="templateItem" />
                      )}
                    </div>
                    <div className="fs-6 text-muted">
                      {tipoItem == TIPO_ITENS.PROJETO ? (
                        intl.formatMessage(
                          { id: 'templateProjetoMensagem' },
                          { projeto: resources.projeto }
                        )
                      ) : (
                        <FormattedMessage id="templateItemMensagem" />
                      )}
                    </div>
                  </div>
                </label>
              )}
            </div>
          ) : modeloItem?.id === MODELO_ITEM.STAGEGATE ? (
            <CreateStageGate model={model}></CreateStageGate>
          ) : (
            <Resumo
              tipoItem={tipoItem}
              modeloItem={modeloItem}
              model={model}
              handleSetFormValues={this.handleSetFormValues}
            />
          )}
        </LoadingContainer>
      </Dialog>
    );
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
    configuracaoSistema: state.user.configuracao,
    modules: state.user.licenca.modulos,
  };
}
export default injectIntl(connect(mapStateToProps)(Template));
